import { useBreadcrumbsContext } from 'app/context';
import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useAuthContext } from 'modules/auth/context';
import { EAccountPermissions } from 'modules/auth/context/permify/permify.interfaces';
import { CessionsContentPage } from './components/CessionsContentPage';
import CessionIcon from 'app/components/Icons/CessionIcon';
import { useTheme } from '@mui/material';

const CessionsPage = () => {
  const theme = useTheme();
  const { id: fundingId } = useParams();
  const { setItems, resetBreadcrumbs } = useBreadcrumbsContext();
  const { userInfo } = useAuthContext();
  const navigate = useNavigate();

  useEffect(() => {
    if (!userInfo?.permissions?.includes(EAccountPermissions.CNAB)) {
      navigate('/');
    }
  }, []);

  useEffect(() => {
    setItems(
      [
        // HK: Ajustar quando Cessão tiver uma page
        { to: `/cession/${fundingId}/cessions`, label: 'Cessão' },
        { to: `/cession/${fundingId}/cessions`, label: 'Cessões' },
      ],
      <CessionIcon color={theme.palette.text.secondary} />,
    );

    return () => resetBreadcrumbs();
  }, []);

  return <CessionsContentPage />;
};

export default CessionsPage;
